import React from "react";
import { Col, ColorPicker, Row, Space } from "antd";
import { ColumnProps } from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  { key: "1", title: "ID", dataIndex: "id", align: "center", width: "10%" },
  { key: "2", title: "Mã mẫu", dataIndex: "id", align: "center", width: "10%" },
  {
    key: "3",
    title: "Tên mẫu điện tim",
    dataIndex: "tenMauDienTim",
    align: "left",
    width: "35%",
  },
  {
    key: "41",
    title: "Người đọc kết quả",
    dataIndex: "tenNguoiDocKQ",
    align: "left",

    width: "20%",
  },
  {
    key: "4",
    title: "Trạng thái",
    dataIndex: "trangThai",
    align: "left",
    render: (text) => {
      return text === true ? "Đang sử dụng" : "Không sử dụng";
    },
    width: "15%",
  },

  { key: "5", title: "Thao tác", dataIndex: "action", width: "10%" },
];
export { columns };
